import React from 'react'
import { Link } from 'react-router-dom'

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">TE</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">TimeshareExit.Expert</h3>
                <p className="text-gray-400 text-sm">Scam-Free • DIY • Guaranteed</p>
              </div>
            </div>
            
            <p className="text-gray-300 text-sm mb-4 max-w-md">
              We expose the timeshare attorney scam and provide you with the same legal strategies 
              they use - for a fraction of the cost. Over 4,800 successful exits and counting.
            </p>
            
            <div className="flex space-x-4">
              <div className="text-sm">
                <span className="text-green-400 font-bold">4,847+</span>
                <span className="text-gray-400 block">Successful Exits</span>
              </div>
              <div className="text-sm">
                <span className="text-green-400 font-bold">$42M+</span>
                <span className="text-gray-400 block">Saved vs. Attorneys</span>
              </div>
              <div className="text-sm">
                <span className="text-green-400 font-bold">97.8%</span>
                <span className="text-gray-400 block">Success Rate</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/calculator" className="text-gray-300 hover:text-white transition-colors">
                  Savings Calculator
                </Link>
              </li>
              <li>
                <a href="#scam-exposed" className="text-gray-300 hover:text-white transition-colors">
                  Scam Exposed
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-gray-300 hover:text-white transition-colors">
                  Success Stories
                </a>
              </li>
              <li>
                <Link to="/register" className="text-gray-300 hover:text-white transition-colors">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:support@ailegalmedia.com" className="text-gray-300 hover:text-white transition-colors">
                  Email Support
                </a>
              </li>
              <li>
                <span className="text-gray-300">Response within 24hrs</span>
              </li>
              <li>
                <span className="text-gray-300">60-Day Guarantee</span>
              </li>
              <li>
                <span className="text-gray-300">AI Legal Media LLC</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400 mb-4 md:mb-0">
              © 2025 AI Legal Media LLC. All rights reserved.
            </div>
            
            <div className="flex space-x-6 text-sm text-gray-400">
              <button className="hover:text-white transition-colors">
                Privacy Policy
              </button>
              <button className="hover:text-white transition-colors">
                Terms of Service
              </button>
              <button className="hover:text-white transition-colors">
                Disclaimer
              </button>
            </div>
          </div>
          
          <div className="mt-4 pt-4 border-t border-gray-800">
            <p className="text-xs text-gray-500 text-center max-w-4xl mx-auto">
              <strong>Disclaimer:</strong> This website provides educational information about consumer rights and 
              legal strategies. We are not a law firm and do not provide legal advice. Individual results may vary. 
              Past performance does not guarantee future results. Consult with a qualified attorney for legal advice specific to your situation.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}